import { i18n } from '../i18n/i18n';
import { i18nLang } from '../i18n/i18nLang';
import * as React from 'react';
import { WActionButton } from '../core/elements/WActionButton';

export function getLanguageSelect(lang: string, cb: (lang: string) => void): JSX.Element {
    const langs = i18nLang.languages.filter((l: string) => l !== lang);
    return (
        <div
            style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center',
                width: 40, backgroundColor: 'rgba(200, 200, 200, 0.5)', borderRadius: 20
            }}
        >
            {renderLangButton(lang, cb)}
            {langs.map((l: string) => renderLangButton(l, cb))}
        </div>
    );
}

function renderLangButton(lang: string, cb: (lang: string) => void): JSX.Element {
    return <WActionButton
        label={`${i18n('Sprache', 'sys')} ${lang.toLocaleUpperCase()}`}
        tooltip={`${i18n('Sprache', 'sys')} ${lang.toLocaleUpperCase()}`}
        key={`lang_${lang}`}
        action={`lang_${lang}`}
        style='big'
        styleProps={{ backgroundColor: '#fff', backgroundSize: '35px 35px', borderRadius: 20 }}
        onAction={() => {
            i18nLang.setUILang(lang);
            cb(lang);
        }}
    />;
}
